<template>
    <div class="chat-message-wrapper" v-bind:style="{'left':calculatePosition(position)}">
            <div class="participants" v-if="showParticipantsList&&isGroupMessage">
                <ul>
                    <li v-for="participant in participants">
                    {{participant.name}}
                    <img :src="participant.roles | roleIcon" class="role-icon">

                </li>
                </ul>
            </div>

            <i class="fa fa-remove close-chat" @click="closeChat()"></i>
            <i v-if="minimized" class="fa fa-window-maximize" @click="minimized=false"></i>
            <i v-if="!minimized" class="fa fa-window-minimize" @click="minimized=true"></i>
            <h5 class="text-center"><span v-if="isGroupMessage" @click="showParticipantsList=!showParticipantsList" class="badge">{{participants.length}}</span>{{chatName}}</h5>{{groupId}}              
            <VuePerfectScrollbar class="scroll-area" >

                <div v-show="!minimized" class="chat-messages" id="chat-messages" 
                v-infinite-scroll="getMore" 
                infinite-scroll-immediate-check="true" 
                infinite-scroll-disabled="busy" 
                infinite-scroll-throttle-delay="250"
                infinite-scroll-distance="300">

                    <div v-show="busy==true" class="loading">    
                        <div class="white loading-image">

                        </div>
                        <div class="blue loading-image">

                        </div>
                    </div>

                    <div class="message" v-for="message in messages">
                        <div class="bubble" v-bind:class="{'mine': message.from == localStorage.user_id || message.userId == localStorage.user_id}">
                        <p v-html="$options.filters.linkify(message.body)"></p>
                        <span v-if="isGroupMessage && localStorage.user_id != message.userId" class="author">{{message.name}}</span>
                        </div> 
                    </div>

                </div>
            </VuePerfectScrollbar>
            <div v-show="!minimized" class="form-group">

                <div class="message-text" ref="messageText"></div>
                <textarea class="message-input form-control" ref="messageInput" v-model="message"></textarea>
                <button @click.prevent="sendMessage()" class="btn btn-sm btn-success">Send</button>
            </div>
        </div>
</template>

<script>

import chat from '../../services/chat';
import randomId from 'random-id';
import emojioneArea from 'emojionearea';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    data() {
        return {
          message: '',
          conversationId: null,
          minimized: false,
          page: 1,
          busy: false,
          emoji:null,
          showParticipantsList: true
        }
    },
    props: ['counterParts','chatName', 'group','isGroupMessage', 'id', 'position'],  
    name: 'chat-messages',
    components: {
        VuePerfectScrollbar
    },
    mounted() {
        var self = this;
        // if (this.isGroupMessage === true) {
        //     this.getGroupConversation(this.group);
        // }       
        var messageInput = this.$refs.messageInput;
        var messageText = this.$refs.messageText;
        
        this.$store.dispatch('splice', {type:'unreadChatMessages', data: this.id})
        this.emoji = $(messageInput).emojioneArea({
          container: messageText,
          shortnames: true,
          hideSource: true,
          events: {
            keydown: function(editor, event) {
                if (event.keyCode === 13 && event.shiftKey === false) {
                    event.preventDefault();
                    self.sendMessage();
                }
            },
          }
        });



    },

    methods: {
        closeChat() {
            this.$store.dispatch('closeChatSession', this.id);
        },
        calculatePosition(position) {
            var right = 50 + (350 * position);
            return right + 'px';
        },
        scrollToBottom() {
           var container = document.querySelector('#chat-messages');
            container.scrollTop = container.scrollHeight;
        },

        sendMessage() {
            var self = this;
            var text = this.emoji.data("emojioneArea").editor.html();

            if (!text) return;

            var message = {
                uuid: localStorage.uuid, 
                userId: localStorage.user_id,
                name: localStorage.user_name,              
                conversationId: self.id, 
                body: text,
                recipients: [this.counterParts]
            };

            if (this.isGroupMessage === true) {
                message.name = localStorage.user_name;
            }

            this.$root.$socket.emit('send_chat_message', message)
          
            this.message = '';
            this.emoji.data("emojioneArea").setText('');

        },
        getGroupConversation() {
            var self = this;
            self.busy = true;

            var counterParts = [this.counterParts];
            var lastId = null;


            if (this.page > 1) {
                var messages = this.$store.getters.chatSession.filter(function(s) {
                     return s.id === self.id
                })[0].messages;

                lastId = messages[messages.length - 1]._id;
            }

            self.$store.dispatch('toggle',{type:'loading', boolean: true});            

            chat.getGroupMessages(this, lastId, this.id).then(function(response) {
                var messages = {
                    type: 'chatMessages'                   
                }

                if (response.data.messages) messages['data'] = response.data.messages;
                else messages['data'] = [];
                self.$store.dispatch('populate', messages);
                self.$store.dispatch('toggle',{type:'loading', boolean: false});            

            }).catch(function(error) {
                console.log(error);
                self.$store.dispatch('toggle',{type:'loading', boolean: false});            

            });
        },
        getMore() {
            this.page++;
            if (this.isGroupMessage) {
                this.getGroupConversation();
            }
            else {
                this.getConversation();
            }  
        },
        getConversation() {
            var self = this;
            self.busy = true;
            var counterParts = [this.counterParts];
            var lastId = null;

            if (this.page > 1) {
                var messages = this.$store.getters.chatSession.filter(function(s) {
                     return s.id === self.id
                })[0].messages;
 
                lastId = messages[messages.length - 1]._id;
            }

            chat.getConversation(this, counterParts, this.page, lastId).then(function(response) { 

                self.$store.dispatch('addMessages', response.data.messages);

                window.setTimeout(function() {
                    self.busy = false;

                },1000)
               
            });
        }

    },
    computed: {
        messages() {            
            var self = this;
            var messages =  this.$store.getters.chatSession.filter(function(s) {
                return s.id === self.id
            })[0].messages;
            return messages
        },
        participants() {
            if (this.isGroupMessage) {
                return this.counterParts.filter(function(u) { return u.id != localStorage.user_id});
            }
        }
    },
    watch: {
        group: function(group) {
            this.getGroupConversation(group);
        },
        counterPart: function() {
            this.scrollToBottom();
            this.getConversation([this.counterPart])
        }
    }

}
</script>

<style lang="scss">
.emoji-mart {
    position:absolute;
    bottom:0;
    background:#444!important;
    border-radius:0!important;
    border:none!important;
    z-index:99999999;
}
.emoji-mart-search input {
    background:transparent;
    border-radius:0!important;
    margin-bottom:2rem;
}
.emoji-mart-category-label span {
    background-color:#444!important;
    color:#fff!important;
}
.bubble a {
    color:#fff;
    text-decoration:underline;
}
</style>
<style lang="scss" scoped>
.message-text {background-color: rgba(0,0,0,.5);}

.loading {
    background:rgba(0,0,0,.8);
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:4rem;
    z-index:99999;
    text-align: center;
    .loading-image {
        height:25px;
        width:25px;
        top:.5rem;
        left:calc(50% - 17.5px)

    }
}
.participants {
    padding-bottom:.5rem;
    li {
        padding:.5rem;
        border-bottom:1px solid #7e7f80;
    }
    li:last-child {
        border-bottom:none;
    }
}
.badge {
    float:left;
    margin-left:1rem;
    cursor:pointer;
}
.toggle-emojis {
    font-size:3rem;
}
h5 {
    border-top: 1px solid #7e7f80;
    border-bottom: 1px solid #7e7f80;
    padding: 1rem 0;
    margin:0;
    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.25);
    z-index: 999;
    text-overflow: ellipsis;
}
.chat-message-wrapper {
    padding:0;
    width: 300px;
    position:fixed;
    bottom:0;
    background:#303133;
    z-index:999999;
    border:1px solid #444;
    box-shadow: 0px 0px 10px 2px rgba(51,51,51,.75);

    .form-group {
        padding:0 1rem;
    }
}
textarea {
    resize: none;
}
::-webkit-scrollbar { 
        display: none;
}
.chat-messages {
    height:200px;
    z-index: 2;
    overflow-y: scroll;
    display:flex;
    flex-direction:column-reverse;
    padding:1rem;
}
textarea.form-control {
    background-color:transparent!important;
    border:1px solid #fff;
    margin:1rem 0;

}

.bubble {
    max-width:75%;
    float:left;
    margin-bottom:1rem;
    p {
        padding:1rem;
        border-radius:3px;
        word-break: break-word;
        background:#0C0C0C;
        margin-bottom: 0;

    }

}
.mine {
    float:right;
    p {
        background:#42b983;
        color:#fff;

    }

}
i {
    float:right;
    margin-right:1rem;
    margin-top:1rem;
    cursor:pointer;
}
.author {
    display:block;
    float:left;
    font-size:1.2rem;
    font-style:italic;
    padding-left:.25rem;
}
</style>




// WEBPACK FOOTER //
// ChatMessages.vue?0c92baa9